/**
 * Passenger service for managing saved passengers
 */
import apiClient from './apiClient';

export const passengerService = {
  /**
   * Get all saved passengers
   * @returns {Promise} List of saved passengers
   */
  getAll: async () => {
    return apiClient.get('/passengers');
  },

  /**
   * Get single passenger by ID
   * @param {number} id - Passenger ID
   * @returns {Promise} Passenger details
   */
  getById: async (id) => {
    return apiClient.get(`/passengers/${id}`);
  },

  /**
   * Save new passenger
   * @param {Object} passengerData - Passenger information
   * @returns {Promise} Created passenger
   */
  create: async (passengerData) => {
    return apiClient.post('/passengers', passengerData);
  },

  /**
   * Update saved passenger
   * @param {number} id - Passenger ID
   * @param {Object} passengerData - Updated passenger information
   * @returns {Promise} Updated passenger
   */
  update: async (id, passengerData) => {
    return apiClient.put(`/passengers/${id}`, passengerData);
  },

  /**
   * Delete saved passenger
   * @param {number} id - Passenger ID
   * @returns {Promise} Success message
   */
  delete: async (id) => {
    return apiClient.delete(`/passengers/${id}`);
  }
};

export default passengerService;
